export default __webpack_public_path__ + "assets/bhutan-flag.png";